/**
 * Created by Rodrigo Quesada on 31/03/17.
 */
import {LifeCertification} from '../../../../domain/model/licenses-certifications/lifecertification/life-certification.model';
import {LicensingExamination} from '../../../../domain/model/licenses-certifications/licensingexamination/licensing-examination.model';
import {ContinuingMedicalEducation} from '../../../../domain/model/licenses-certifications/cme/continuing-medical-education.model';
import {formatMonthYear, toOrderValue} from '../../../shared/utils';

//region Other Classes
export type OtherCertificationType = LifeCertification | LicensingExamination | ContinuingMedicalEducation;

export enum OtherCertificationTypeId {LIFE = 1, LICENSING, CME}

abstract class OtherCertificationEntryData {
    type: OtherCertificationTypeId;
    name?: string;
    completionDate?: string;
    expirationDate?: string;

    constructor(otherCertificationType: OtherCertificationEntryType<any>) {
        this.type = otherCertificationType.id;
    }
}

abstract class OtherCertificationEntryType<T extends OtherCertificationType> {

    constructor(readonly id: OtherCertificationTypeId, private readonly _modelType: new () => T) {
    }

    isType(model: OtherCertificationType): model is T { return model instanceof this._modelType; }

    abstract toEntryData(model: T): Partial<OtherCertificationEntryData>

    abstract orderValueFor(model: T): number
}

class LifeCertificationEntryType extends OtherCertificationEntryType<LifeCertification> {

    constructor() { super(OtherCertificationTypeId.LIFE, LifeCertification); }

    toEntryData(model: LifeCertification): Partial<OtherCertificationEntryData> {
        return {
            name: model.certificationType,
            expirationDate: formatMonthYear(model.expirationDate)
        };
    }

    orderValueFor(model: LifeCertification): number { return toOrderValue(model.expirationDate); }
}

class LicensingExaminationEntryType extends OtherCertificationEntryType<LicensingExamination> {

    constructor() { super(OtherCertificationTypeId.LICENSING, LicensingExamination); }

    toEntryData(model: LicensingExamination): Partial<OtherCertificationEntryData> {
        return {
            name: model.certificationType,
            completionDate: formatMonthYear(model.completionDate)
        };
    }

    orderValueFor(model: LicensingExamination): number { return toOrderValue(model.completionDate); }
}

class ContinuingMedicalEducationEntryType extends OtherCertificationEntryType<ContinuingMedicalEducation> {

    constructor() { super(OtherCertificationTypeId.CME, ContinuingMedicalEducation); }

    toEntryData(model: ContinuingMedicalEducation): Partial<OtherCertificationEntryData> {
        return {
            name: model.issuingEntity,
            completionDate: formatMonthYear(model.completionDate)
        };
    }

    orderValueFor(model: ContinuingMedicalEducation): number { return toOrderValue(model.completionDate); }
}
//endregion

const otherCertificationTypes: OtherCertificationEntryType<any>[] = [
    new LifeCertificationEntryType(),
    new LicensingExaminationEntryType(),
    new ContinuingMedicalEducationEntryType()
];

export class OtherCertificationEntry extends OtherCertificationEntryData {

    private _orderValue: number;

    constructor(otherCertification: OtherCertificationType) {
        const otherCertificationType = otherCertificationTypes.find(it => it.isType(otherCertification))!;
        super(otherCertificationType);

        Object.assign(this, otherCertificationType.toEntryData(otherCertification));

        this._orderValue = otherCertificationType.orderValueFor(otherCertification);
    }

    compareTo(other: OtherCertificationEntry) {
        //reverse order from latest/null to oldest
        return -(this._orderValue - other._orderValue);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/download/document/other-certifications-entry.class.ts